import { useSelector } from "react-redux";
// metadata
import { Helmet, HelmetProvider } from "react-helmet-async";

interface AppHelmetTypes {
  isDefaultDomain: boolean;
}

export default function AppHelmet({ isDefaultDomain }: AppHelmetTypes) {
  // states
  const tenantInfo = useSelector((state: any) => state.tenant.tenantInfo);

  return (
    <HelmetProvider>
      <Helmet>
        {/* TBD: This should be done with Translation user stories, to be dynamically according to language selected and should be handled on server side (remove this if is unnecessary)  */}
        <html lang="en" /> {/* Set the language of your content */}
        <title>{isDefaultDomain ? "Get Local" : tenantInfo?.name}</title>
        <meta
          name="description"
          content={
            isDefaultDomain ? `Get Local : The key to the city` : `${tenantInfo?.name} : ${tenantInfo?.address?.city}`
          }
        />
        {/* Open Graph tags */}
        <meta property="og:title" content={isDefaultDomain ? "Get Local" : tenantInfo?.name} />
        <meta
          property="og:description"
          content={
            isDefaultDomain ? `Get Local : The key to the city` : `${tenantInfo?.name} : ${tenantInfo?.address?.city}`
          }
        />
        {/* TBD: This should be done with Translation user stories, to be dynamically according to language selected and should be handled on server side (remove from this if is unnecessary)   */}
        <meta property="og:locale" content="en_GB" /> {/* Set the Open Graph locale */}
      </Helmet>
    </HelmetProvider>
  );
}
